export const errorResponseHelper = error => {
  return {
    status: !error.response ? null : error.response?.status,
    token: !error.response ? null : error.response?.data?.token,
  };
};
